import { useEffect, useState } from "react";
import CannedResponseHeader from "../common/CannedResponseHeader/CannedResponseHeader";
import CannedResponsesTab from "../common/CannedResponsesTab/CannedResponsesTab";
import CannedMRTable from "./CannedMRTable/CannedMRTable";
import CannedResourceModal from "../common/modal/CannedResourceModal/CannedResourceModal";
import CustomPagination from "components/dashboard/common/CustomPagination/CustomPagination";
import { Empty, Loading } from "components/ui";
import ErrorView from "components/ui/ErrorView/ErrorView";
import { getErrorMessage, getPageFromCache } from "utils/helper";
import { CANNED_RESOURCE_ACTIONS, CANNED_RESOURCE_TYPES } from "../enum";
import { dataQueryStatus } from "utils";
import { apiRoute } from "services";
import API from "services/lib/api";
import { useDispatch, useSelector } from "react-redux";
import { setCannedMentionsFilterParams } from "store/filters/actions";
import {
    clearCannedMentions,
    saveCannedMentions,
} from "store/modules/agentAssistance/actions";

const { CREATE_CANNED_RESOURCE, EDIT_CANNED_RESOURCE } =
    CANNED_RESOURCE_ACTIONS;

const { IDLE, LOADING, ERROR, DATAMODE, NULLMODE } = dataQueryStatus;

const CannedMentionsResponses = () => {
    const [errorMssg, setErrorMssg] = useState();
    const [showModal, toggleModal] = useState(false);
    const [cannedMentions, setCannedMentions] = useState([]);

    const [selectedCannedResource, selectCannedResource] = useState();

    const [modalAction, setModalAction] = useState();

    const [tableIsLoading, setTableIsLoading] = useState(false);
    const [useTableLoader, setUseTableLoader] = useState(false);
    const [searchIsLoading, setSearchIsLoading] = useState(false);
    const [clearSearch, setClearSearch] = useState(false);

    const {
        cannedMentionsCache: { pages, totalRecords },
    } = useSelector((state) => state.agentAssistance);

    const { filterParams } = useSelector(
        (state) => state?.filters?.cannedMentionsFilters
    );

    const [status, setStatus] = useState(
        pages[filterParams?.currentPage]?.length > 0 ? DATAMODE : IDLE
    );

    const cannedResourceType = CANNED_RESOURCE_TYPES?.MENTIONS;

    const dispatch = useDispatch();

    const handleSearch = (search) => {
        setUseTableLoader(true);
        setSearchIsLoading(true);
        setClearSearch(false);

        dispatch(setCannedMentionsFilterParams({ currentPage: 1, search }));
        dispatch(clearCannedMentions());
    };

    const handlePageChange = (currentPage) => {
        setUseTableLoader(true);

        dispatch(
            setCannedMentionsFilterParams({ ...filterParams, currentPage })
        );
    };

    const getCannedMentions = async () => {
        try {
            setErrorMssg();
            useTableLoader && setTableIsLoading(true);
            if (cannedMentions?.length < 1 && filterParams?.search < 1) {
                setStatus(LOADING);
            }
            const url = apiRoute.getCannedResources;
            const res = await API.get(url, {
                params: {
                    cannedResourceType,
                    ...filterParams,
                },
            });

            if (res.status === 200) {
                filterParams?.search?.length > 0 && setUseTableLoader(true);
                const { data, metaData } = res.data;
                let newStatus = data.length > 0 ? DATAMODE : NULLMODE;
                setCannedMentions(data);

                dispatch(
                    saveCannedMentions(
                        filterParams?.currentPage,
                        metaData?.totalRecords,
                        data
                    )
                );
                setStatus(newStatus);
                setSearchIsLoading(false);
                setTableIsLoading(false);
            }
        } catch (err) {
            setSearchIsLoading(false);
            setErrorMssg(getErrorMessage(err));
            useTableLoader ? setTableIsLoading(false) : setStatus(ERROR);
        }
    };

    const handleSuccess = () => {
        dispatch(setCannedMentionsFilterParams({ currentPage: 1, search: "" }));
        dispatch(clearCannedMentions());
        setClearSearch(true);
        getCannedMentions();
    };

    const handleActionModal = (actionType, cannedResource) => {
        setModalAction(actionType);
        selectCannedResource(cannedResource);
        toggleModal(true);
    };

    const renderBasedOnStatus = () => {
        switch (status) {
            case IDLE:
                return "";

            case LOADING:
                return <Loading />;

            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getCannedMentions}
                    />
                );

            case NULLMODE:
                return <Empty text={"No Canned Resource Available Yet"} />;

            case DATAMODE:
                return (
                    <>
                        <CannedMRTable
                            handleSuccess={handleSuccess}
                            handleActionModal={handleActionModal}
                            modalAction={modalAction}
                            cannedMentions={cannedMentions}
                            tableIsLoading={tableIsLoading}
                        />
                        <CustomPagination
                            totalRecords={totalRecords}
                            handlePageChange={handlePageChange}
                            {...filterParams}
                        />
                    </>
                );

            default:
                return "";
        }
    };

    useEffect(() => {
        const cachedPage = getPageFromCache(pages, filterParams.currentPage);
        if (cachedPage?.length > 0 && !searchIsLoading) {
            setCannedMentions(cachedPage);
        } else {
            getCannedMentions();
        }
        // eslint-disable-next-line
    }, [filterParams, useTableLoader]);

    const isEdit = modalAction === EDIT_CANNED_RESOURCE;

    return (
        <>
            <CannedResponsesTab />
            <div className='padded__layout'>
                <CannedResponseHeader
                    title={"Canned mentions"}
                    subTitle={"Add and edit canned mentions"}
                    btnText={"Create new canned mention"}
                    placeholder='Search mention here'
                    handleClick={() =>
                        handleActionModal(CREATE_CANNED_RESOURCE)
                    }
                    handleSearch={handleSearch}
                    searchIsLoading={searchIsLoading}
                    clearSearch={clearSearch}
                    defaultValue={filterParams?.search}
                />
                {renderBasedOnStatus()}
            </div>

            {showModal && (
                <CannedResourceModal
                    title={
                        isEdit ? "Update Canned Mention" : "New Canned Mention"
                    }
                    showModal={showModal}
                    closeModal={() => toggleModal(false)}
                    cannedResourceType={cannedResourceType}
                    toggleModal={toggleModal}
                    modalAction={modalAction}
                    selectedCannedResource={selectedCannedResource}
                    handleSuccess={handleSuccess}
                />
            )}
        </>
    );
};

export default CannedMentionsResponses;
